import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import './boot';
import { axiosSettings } from './utils/authorization';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: 'AIzaSyAiWU4WDz2vG7NAMMYx2lyJkXck1mgedek',
//   authDomain: 'ploooto.firebaseapp.com',
//   projectId: 'ploooto',
//   storageBucket: 'ploooto.appspot.com',
//   messagingSenderId: '116403345427',
//   appId: '1:116403345427:web:2c7c0704b71cb6ce0847e6',
//   measurementId: 'G-TK6C2T5ZW3',
// };
//
// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

axiosSettings();

// 개발 환경에서 ResizeObserver 루프 경고가 에러 오버레이로 뜨는 현상 완화
// (실제 기능 오류가 아닌 브라우저/라이브러리 경고)
if (process.env.NODE_ENV === 'development') {
  const isResizeObserverLoopWarning = (value) => (
    typeof value === 'string'
    && (
      value.includes('ResizeObserver loop completed with undelivered notifications')
      || value.includes('ResizeObserver loop limit exceeded')
    )
  );

  // ResizeObserver 콜백을 다음 프레임으로 미뤄 루프 경고 자체를 완화
  if (typeof window !== 'undefined' && window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
  }

  window.addEventListener('error', (event) => {
    if (
      isResizeObserverLoopWarning(event?.message)
      || isResizeObserverLoopWarning(event?.error?.message)
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    if (
      isResizeObserverLoopWarning(event?.reason?.message)
      || isResizeObserverLoopWarning(String(event?.reason || ''))
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
